import { trimEnd } from 'lodash';
export var limitLength = function (text, length) {
    if (text === void 0) { text = ''; }
    return text.substring(0, length);
};
export var removeTrailingSlash = function (text) { return trimEnd(text, '/'); };
